
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { List, History, DollarSign, Users, FileText, GraduationCap } from 'lucide-react';

const MenuItem = ({ icon: Icon, title, description, path, colorClass = "bg-blue-50", iconColor = "text-blue-600" }) => {
    const navigate = useNavigate();
    const isEnabled = !!path;

    return (
        <button
            onClick={() => isEnabled && navigate(path)}
            className={`w-full text-left p-4 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center transition-all ${isEnabled ? 'active:scale-95 hover:bg-gray-50' : 'opacity-50 cursor-not-allowed'}`}
            disabled={!isEnabled}
        >
            <div className={`p-3 ${colorClass} rounded-xl mr-4`}>
                <Icon className={`w-6 h-6 ${iconColor}`} />
            </div>
            <div className="flex-1 min-w-0">
                <h3 className="font-bold text-gray-800 text-sm uppercase tracking-tight">{title}</h3>
                <p className="text-[11px] text-gray-500 leading-tight">{description}</p>
            </div>
        </button>
    );
};

const FluxoScreen = () => {
    return (
        <div className="p-4 h-full overflow-y-auto bg-gray-50 pb-24 text-left">
            <div className="mb-8 mt-2 px-1">
                <h1 className="text-2xl font-bold text-gray-800">Meu Fluxo</h1>
                <p className="text-xs text-gray-500 font-medium uppercase tracking-widest mt-1">Gestão e Produtividade</p>
            </div>

            <div className="space-y-3">
                <MenuItem
                    icon={List}
                    title="Serviços Ativos"
                    description="Lista e Agenda de compromissos agendados."
                    path="/servi/fluxo/ativos"
                />
                 <MenuItem
                    icon={FileText}
                    title="Meus Orçamentos"
                    description="Gerencie todas as suas propostas enviadas."
                    path="/proposals"
                />
                <MenuItem
                    icon={History}
                    title="Histórico"
                    description="Consulte todos os serviços que já foram finalizados."
                    path="/servi/fluxo/historico"
                />
                <MenuItem
                    icon={DollarSign}
                    title="Faturamento"
                    description="Acompanhe seus ganhos reais por período."
                    path="/servi/fluxo/faturamento"
                />
                <MenuItem
                    icon={Users}
                    title="Gestão de Clientes"
                    description="Veja a lista de clientes atendidos no período."
                    path="/servi/fluxo/clientes"
                />

                <div className="pt-2">
                    <MenuItem
                        icon={GraduationCap}
                        title="T-SERVI Academy"
                        description="Sugestões de cursos e capacitação externa."
                        path="/servi/academy"
                        colorClass="bg-purple-50"
                        iconColor="text-purple-600"
                    />
                </div>
            </div>
        </div>
    );
};

export default FluxoScreen;
